import { createPaperlessTheme } from "../../theme/createPaperlessTheme";

export const employeeTheme = createPaperlessTheme("pn-employee-portal");
